export default __webpack_public_path__ + "static/qawhat-3-f7b19aa16ef48b40f7e23dd6da78e695.png";